import { ACTIONS, USERTYPES } from "../../../constants/Constants";
import { normalizeEmail } from "../../../helpers/NormalizeEmail";
import { encryptData } from "../../../helpers/RSAUtility";
import { addRadiologist, addUser, editRadiologist, editUser } from "../../../service/UserService";

export const submitUserData = async (state, values, checkFirmNew, firmId, firmList, userData, userType, selectedModalityForFirm, selectedModalityWithSubModality, checkAllFirm) => {
  console.log("Values in submitUserData ", values)
  console.log(checkFirmNew);
  const encryptedFirstName = encryptData(values.firstName);
  const encryptedLastName = encryptData(values.lastName);
  const encryptedEmail = encryptData(normalizeEmail(values.email));
  const encryptedMobile = encryptData(values.mobile);
  const encryptedUsername = encryptData(values.username);
  const encryptedPassword = encryptData(values.password);
  const encryptedConfirmPassword = encryptData(values.confirmPassword);
  const encryptedAction = encryptData(values.action);
  const role = encryptData(userType);

  const enableWA = !!values.enableWhatsApp;
  const waNumber = enableWA && values.whatsappNumber ? values.whatsappNumber : null;
  const enableEmail = !!values.enableEmail; 
  let modalityIdList = [];
  let technicianContactList = [];
  let response;

      if (
        userType === USERTYPES.ADMIN ||
        userType === USERTYPES.FIRMADMIN
      ) {
        //USER DTO FOR ADD
        if (state.action === ACTIONS.ADD) {
          const userDto = {
            username: encryptedUsername,
            password: encryptedPassword,
            confirmPassword: encryptedConfirmPassword,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            accountNonLocked : values.accountNonLocked,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            enableLlmReport: values.enableLlmReport ? 1 : 0,
            role,
            showConfirmation: values.showConfirmation,
            signatureDto: {
              signatureRequired: false,
              signatureText: values.signatureText,
              signatureImage: values.signatureDto.signatureImage != null ? values.signatureDto.signatureImage : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            // technicianContactList: userData?.user?.technicianContactList
            technicianContactList: values.technicianContactList,
            showWord: values.showWord ? 1 : 0,
            peerReviewAdmin:values.isPeerReviewAdmin,
            peerReviewEvaluator:values.isPeerReviewEvaluator,
            passwordResetAllowed:values.isPasswordResetAllowed,
            forcedLogoutAllowed:values.isForcedLogoutAllowed,
            exportCsvAllowed:values.isExportCsvAllowed,
            enableWhatsApp: enableWA,
            whatsappNumber: waNumber,
            enableEmail,  
            //sendWelcomNotification: values.sendWelcomNotification ? 1 : 0,
            sendWelcomeNow: values.sendWelcomNotification ? 1 : 0,

          };

                    response = await addUser(userDto,firmId);
        }
        //USER DTO FOR EDIT
        else if (state.action === ACTIONS.EDIT) {
          const userDto = {
            id: values.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            accountNonLocked : values.accountNonLocked,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            enableLlmReport: values.enableLlmReport ? 1 : 0,

            role,
            showConfirmation: values.showConfirmation,
            signatureDto: {
              signatureRequired: false,
              signatureText: values.signatureText,
              signatureImage: values.signatureDto.signatureImage != null ? values.signatureDto.signatureImage : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            // technicianContactList: userData?.user?.technicianContactList
            technicianContactList: values.technicianContactList,
            showWord: values.showWord ? 1 : 0,
            peerReviewAdmin:values.isPeerReviewAdmin,
            peerReviewEvaluator:values.isPeerReviewEvaluator,
            passwordResetAllowed:values.isPasswordResetAllowed,
            forcedLogoutAllowed:values.isForcedLogoutAllowed,
            exportCsvAllowed:values.isExportCsvAllowed,
            enableWhatsApp: enableWA,
            whatsappNumber: waNumber,
            enableEmail,  
          };

          response = await editUser(userDto,firmId);
        }
      } else if (userType === USERTYPES.SUPERVISOR) {
        //USER DTO FOR ADD
        if (state.action === ACTIONS.ADD) {
          const userDto = {
            username: encryptedUsername,
            password: encryptedPassword,
            confirmPassword: encryptedConfirmPassword,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            accountNonLocked : values.accountNonLocked,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            capacity: values.capacity,
            role,
            firmIdListNew: checkFirmNew,
            showRadiologistTime: values.showRadiologistTime,
            userFirmDto: {
              firmId: firmId,
              firmRequired: true,
            },
            selectedModalityForFirm: selectedModalityForFirm.filter((mod) => String(mod)),
            modalityWithSubModalityPreferences:selectedModalityWithSubModality,
            qcSupervisor: values.qcSupervisor ? 1: 0,
            keyImage: values.keyImage ? 1: 0,
            allowTextAnnotation: !!values.allowTextAnnotation,
            qcSaveReport: values.qcSaveReport ? 1: 0,
            qcOutsourceLogin: values.qcOutsourceLogin ? 1: 0,
            showConfirmation: values.showConfirmation,
            signatureDto: {
              signatureRequired: false,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            showWord: values.showWord ? 1 : 0,
            peerReviewAdmin:values.isPeerReviewAdmin,
            peerReviewEvaluator:values.isPeerReviewEvaluator,
            enableWhatsApp: enableWA,
            whatsappNumber: waNumber,
            enableEmail,  
            //sendWelcomNotification: values.sendWelcomNotification ? 1 : 0,
            sendWelcomeNow: values.sendWelcomNotification ? 1 : 0,
            exportCsvAllowed:values.isExportCsvAllowed,
            forcedLogoutAllowed:values.isForcedLogoutAllowed,
            enableStudyUpload: values.enableStudyUpload,
            allowDeleteStudy: values.allowDeleteStudy,
          };
          console.log(userDto)
          response = await addUser(userDto,firmId);
        }
        //USER DTO FOR EDIT
        else if (state.action === ACTIONS.EDIT) {
          const userDto = {
            id: values.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            accountNonLocked : values.accountNonLocked,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            capacity: values.capacity,
            role,
            firmIdListNew: checkFirmNew,
            showRadiologistTime: values.showRadiologistTime,
            userFirmDto: {
              firmId: firmId,
              firmRequired: true,
            },
            selectedModalityForFirm: selectedModalityForFirm.filter((mod) => String(mod)),
            modalityWithSubModalityPreferences:selectedModalityWithSubModality,
            qcSupervisor: values.qcSupervisor ? 1: 0,
            keyImage: values.keyImage ? 1: 0,
            allowTextAnnotation: !!values.allowTextAnnotation,
            qcSaveReport: values.qcSaveReport ? 1: 0,
            qcOutsourceLogin: values.qcOutsourceLogin ? 1: 0,
            allhospitalAccess: userData.user.allhospitalAccess,
            showConfirmation: values.showConfirmation,
            signatureDto: {
              signatureRequired: false,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            showWord: values.showWord ? 1 : 0,
            peerReviewAdmin:values.isPeerReviewAdmin,
            peerReviewEvaluator:values.isPeerReviewEvaluator,
            enableWhatsApp: enableWA,
            whatsappNumber: waNumber,
            enableEmail, 
            exportCsvAllowed:values.isExportCsvAllowed,
            forcedLogoutAllowed:values.isForcedLogoutAllowed, 
            enableStudyUpload: values.enableStudyUpload,
            allowDeleteStudy: values.allowDeleteStudy,
          };

          response = await editUser(userDto,firmId);
        }
      } else if (
        userType === USERTYPES.FIRMDOCTOR ||
        userType === USERTYPES.FIRMTECHNICIAN
      ) {
        //USER DTO FOR ADD
        if (state.action === ACTIONS.ADD) {
          const userDto = {
            username: encryptedUsername,
            password: encryptedPassword,
            confirmPassword: encryptedConfirmPassword,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            role,
            firmIdListNew: checkFirmNew,
            userFirmDto: {
              firmId: firmId,
              firmRequired: true,
            },
            signatureDto: {
              signatureRequired: false,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            technicianContactList: values.technicianContactList != null ? values.technicianContactList : [],
            enableReportAndHeaderTemplateConfigurations:values.enableReportAndHeaderTemplateConfigurations,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            accountNonLocked : values.accountNonLocked,
            enableStudyUpload: values.enableStudyUpload,
            allowStudyEdit: values.allowStudyEdit,
            showAiResults: values.showAiResults,
            showSavedReport: values.showSavedReport,
            showViewerTechnician: values.showViewerTechnician,
            enableWhatsApp: enableWA,
            whatsappNumber: waNumber,
            enableEmail,  
            //sendWelcomNotification: values.sendWelcomNotification ? 1 : 0,
            sendWelcomeNow: values.sendWelcomNotification ? 1 : 0,
            exportCsvAllowed: values.isExportCsvAllowed ? 1 : 0,
          };

          response = await addUser(userDto,firmId);
        }
        //USER DTO FOR EDIT
        else if (state.action === ACTIONS.EDIT) {
          const userDto = {
            id: values.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            role,
            capacity: userData.user.capacity,
            firmIdListNew: checkFirmNew,
            userFirmDto: {
              firmId: firmId,
              firmRequired: true,
            },
            signatureDto: {
              signatureRequired: false,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            technicianContactList : values.technicianContactList != null ? values.technicianContactList : [],
            enableReportAndHeaderTemplateConfigurations:values.enableReportAndHeaderTemplateConfigurations,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            accountNonLocked : values.accountNonLocked,
            enableStudyUpload: values.enableStudyUpload,
            allowStudyEdit: values.allowStudyEdit,
            showAiResults: values.showAiResults,
            showSavedReport: values.showSavedReport,
            showViewerTechnician: values.showViewerTechnician,
            enableWhatsApp: enableWA,
            whatsappNumber: waNumber,
            enableEmail,  
            exportCsvAllowed: values.isExportCsvAllowed ? 1 : 0,
          };

          response = await editUser(userDto,firmId);
        }
      } else if(userType === USERTYPES.RADIOLOGIST) {

        modalityIdList.push(values.firstModalityPreference);
        modalityIdList.push(values.secondModalityPreference);
        modalityIdList.push(values.thirdModalityPreference);
        
        if (state.action === ACTIONS.ADD) {
          const userDto = {
            username: encryptedUsername,
            password: encryptedPassword,
            confirmPassword: encryptedConfirmPassword,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            qcRadiologist: values.qcRadiologist ? 1 : 0,
            skipQC: values.skipQC ? 1 : 0,
            capacity: values.capacity,
            showAllStudies: values.showAllStudies ? 1 : 0,
            disableSubmit: values.disableSubmit,
            sendAssignMail: values.sendAssignMail ? 1 : 0,
            sendFeedbackMail: values.sendFeedbackMail ? 1 : 0,
            //sendWelcomNotification: values.sendWelcomNotification ? 1 : 0,
            sendWelcomeNow: values.sendWelcomNotification ? 1 : 0,
            checkCapacityOnManualAssign: values.checkCapacityOnManualAssign ? 1 : 0,
            onPayroll: values.onPayroll,
            uploadStudy: values.uploadStudy,
            addQCRadiologist: false,
            radiologistType: values.radiologistType,
            allhospitalAccess: checkAllFirm ? 1 : 0,
            radiologistProvider: userData.radiologistProvider,
            role,
            firmIdListNew: checkFirmNew,
            userFirmDto: {
              firmRequired: false,
            },
            selectedModalityForFirm: selectedModalityForFirm.filter((mod) => String(mod)),
            modalityWithSubModalityPreferences:selectedModalityWithSubModality,
            // signatureDto: {
            //   signatureRequired: true,
            //   signatureText: values.signatureText,
            //   signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
            //   isSignatureImageDeleted: values.signatureDto.isSignatureImageDeleted ? 1 : 0
            // },
            signatureDto: {
              signatureRequired: true,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },

            modalityIdList: modalityIdList.filter((modality) => String(modality)),
            pediatricSpecialist: values.pediatricSpecialist ? 1 : 0,
            specialist: (values.specialist || "").trim(),
            selectedPediatricModalityId: values.selectedPediatricModalityId,
            enableTypistWorkflow: values.enableTypistWorkflow,
            enableHistoryUpload: values.enableHistoryUpload,
            enablePrelimnaryReviewWorkflow: !!values.enablePrelimnaryReviewWorkflow,
            showClientName: values.showClientName,  
            showWord: values.showWord ? 1 : 0,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            accountNonLocked : values.accountNonLocked,
            enableLlmReport : values.enableLlmReport ? 1 : 0,
            enableWhatsApp: enableWA,
            whatsappNumber: waNumber,
            enableEmail,  

          };
          response = await addRadiologist(userDto, userDto.signatureDto.signatureImage);
        }
        //USER DTO FOR EDIT
        else if (state.action === ACTIONS.EDIT) {
          const userDto = {
            id: values.id,
            username: encryptedUsername,
            password: encryptedPassword,
            confirmPassword: encryptedConfirmPassword,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            qcRadiologist: values.qcRadiologist ? 1 : 0,
            skipQC: values.skipQC ? 1 : 0,
            capacity: values.capacity,
            showAllStudies: values.showAllStudies ? 1 : 0,
            disableSubmit: values.disableSubmit,
            sendAssignMail: values.sendAssignMail ? 1 : 0,
            sendFeedbackMail: values.sendFeedbackMail ? 1 : 0,
            checkCapacityOnManualAssign: values.checkCapacityOnManualAssign ? 1 : 0,
            onPayroll: values.onPayroll,
            uploadStudy: values.uploadStudy,
            radiologistType: values.radiologistType,
            allhospitalAccess: checkAllFirm ? 1 : 0,
            radiologistProvider: userData.radiologistProvider,
            role,
            firmIdListNew: checkFirmNew,
            userFirmDto: {
              firmRequired: false,
            },
            selectedModalityForFirm: selectedModalityForFirm.filter((mod) => String(mod)),
            modalityWithSubModalityPreferences:selectedModalityWithSubModality,
            signatureDto: {
              signatureRequired: userData.user.signatureDto.signatureRequired,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            modalityIdList: modalityIdList.filter((modality) => String(modality)),
            pediatricSpecialist: values.pediatricSpecialist ? 1 : 0,
            specialist: (values.specialist || "").trim(),
            selectedPediatricModalityId: values.selectedPediatricModalityId,
            enableTypistWorkflow: values.enableTypistWorkflow,
            enableHistoryUpload: values.enableHistoryUpload,
            enablePrelimnaryReviewWorkflow: !!values.enablePrelimnaryReviewWorkflow,
            showClientName: values.showClientName,
            showWord: values.showWord ? 1 : 0,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            enableLlmReport : values.enableLlmReport ? 1 : 0,
            accountNonLocked : values.accountNonLocked,
            enableWhatsApp: enableWA,
            whatsappNumber: waNumber,
            enableEmail,  

          };

          response = await editRadiologist(userDto, userDto.signatureDto.signatureImage);
      }
    }else if (
      userType === USERTYPES.TYPIST
    ) {
      //USER DTO FOR ADD
      if (state.action === ACTIONS.ADD) {
        const userDto = {
          username: encryptedUsername,
          password: encryptedPassword,
          confirmPassword: encryptedConfirmPassword,
          firstName: encryptedFirstName,
          lastName: encryptedLastName,
          email: encryptedEmail,
          mobile: encryptedMobile,
          action: encryptedAction,
          active: values.active,
          role,
          firmIdListNew: checkFirmNew,
          userFirmDto: {
            firmId: firmId,
            firmRequired: true,
          },
          signatureDto: {
            signatureRequired: false,
            signatureText: values.signatureText,
            signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
            isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            signatureImageUrl : values.signatureDto.signatureImageUrl
          },
          showWord: values.showWord,
          twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
          accountNonLocked : values.accountNonLocked,
            enableWhatsApp: enableWA,
            whatsappNumber: waNumber,
            enableEmail,  
            //sendWelcomNotification: values.sendWelcomNotification ? 1 : 0,
            sendWelcomeNow: values.sendWelcomNotification ? 1 : 0,
            showAllStudy: values.showAllStudy,
            showAddStudy: values.showAddStudy ? 1 : 0,
            showChats: values.showChats ? 1 : 0,
            showHistory: values.showHistory ? 1 : 0,
            showViewer: values.showViewer ? 1 : 0,
            allowSubmit: values.allowSubmit ? 1 : 0,
            connectedRadiologistIds: values.connectedRadiologistIds,
        };

        response = await addUser(userDto,firmId);
      }
      //USER DTO FOR EDIT
      else if (state.action === ACTIONS.EDIT) {
        const userDto = {
          id: values.id,
          username: encryptedUsername,
          firstName: encryptedFirstName,
          lastName: encryptedLastName,
          email: encryptedEmail,
          mobile: encryptedMobile,
          action: encryptedAction,
          active: values.active,
          role,
          capacity: userData.user.capacity,
          firmIdListNew: checkFirmNew,
          userFirmDto: {
            firmId: firmId,
            firmRequired: true,
          },
          signatureDto: {
            signatureRequired: false,
            signatureText: values.signatureText,
            signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
            isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            signatureImageUrl : values.signatureDto.signatureImageUrl
          },
          showWord: values.showWord,
          twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
          accountNonLocked : values.accountNonLocked,
            enableWhatsApp: enableWA,
            whatsappNumber: waNumber,
            enableEmail,
            showAllStudy: values.showAllStudy,
            showAddStudy: values.showAddStudy ? 1 : 0,
            showChats: values.showChats ? 1 : 0,
            showHistory: values.showHistory ? 1 : 0,
            showViewer: values.showViewer ? 1 : 0,
            allowSubmit: values.allowSubmit ? 1 : 0,
            connectedRadiologistIds: values.connectedRadiologistIds,
        };

        response = await editUser(userDto,firmId);
      }
    }
    return response;
};

export const submitUserProfileData = async (loggedInUserRole, values, profileData) => {
  console.log(loggedInUserRole)
  console.log(values)
  console.log(profileData)
  const encryptedFirstName = encryptData(values.firstName);
  const encryptedLastName = encryptData(values.lastName);
  const encryptedEmail = encryptData(normalizeEmail(values.email));
  const encryptedMobile = encryptData(values.mobile);
  const encryptedUsername = encryptData(values.username);
  const encryptedAction = encryptData(values.action);
  const role = encryptData(loggedInUserRole);
  const enableWA = !!values.enableWhatsApp;
  const enableWhatsAppFlag = !!values.useWhatsApp;  
  const enableEmailFlag = !!values.useEmail; 
  const waPhone = values.whatsappNumber || null;


  let response;

      if (
        loggedInUserRole === USERTYPES.ADMIN ||
        loggedInUserRole === USERTYPES.FIRMADMIN
      ) {
          const userDto = {
            id: profileData.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            role,
            //whatsappUserpref: useWA,
            whatsappNumber: waPhone,
            //emailUserpref: useEmail,
            enableWhatsApp: enableWhatsAppFlag,
            enableEmail: enableEmailFlag,
            showConfirmation: values.showConfirmation,
            signatureDto: {
              signatureRequired: false,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            },
            technicianContactList: values?.technicianContactList,
            accountNonLocked : profileData.accountNonLocked,
            exportCsvAllowed : profileData.exportCsvAllowed
          };

          response = await editUser(userDto);

      } else if (loggedInUserRole === USERTYPES.SUPERVISOR) {
          const userDto = {
            id: profileData.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            capacity: profileData.capacity,
            role,
            //whatsappUserpref: useWA,
            whatsappNumber: waPhone,
            //emailUserpref: useEmail,
            enableWhatsApp: enableWhatsAppFlag,
            enableEmail: enableEmailFlag,
            showRadiologistTime: values.showRadiologistTime,
            qcSupervisor: profileData.qcSupervisor,
            qcSaveReport: profileData.qcSaveReport,
            qcOutsourceLogin: profileData.qcOutsourceLogin,
            showConfirmation: values.showConfirmation,
            signatureDto: {
              signatureRequired: false,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            },
            keyImage:profileData.keyImage,
            allowTextAnnotation:profileData.allowTextAnnotation,
            accountNonLocked : profileData.accountNonLocked,
            exportCsvAllowed : profileData.exportCsvAllowed,
            enableStudyUpload : profileData.enableStudyUpload
          };
          
          response = await editUser(userDto);
        
      } else if (
        loggedInUserRole === USERTYPES.FIRMDOCTOR ||
        loggedInUserRole === USERTYPES.FIRMTECHNICIAN
      ) {
          const userDto = {
            id: profileData.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            role,
            //whatsappUserpref: useWA,
            whatsappNumber: waPhone,
            //emailUserpref: useEmail,
            enableWhatsApp: enableWhatsAppFlag,
            enableEmail: enableEmailFlag,
            //capacity: 10,
            // userFirmDto: {
            //   firmId: firmId,
            //   firmRequired: true,
            // },
            enableReportAndHeaderTemplateConfigurations: profileData.enableReportAndHeaderTemplateConfigurations,
            signatureDto: {
              signatureRequired: false,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            },
            technicianContactList: values?.technicianContactList,
            accountNonLocked : profileData.accountNonLocked,
            enableStudyUpload : profileData.enableStudyUpload
          };
          
          response = await editUser(userDto);
        
      } else if(loggedInUserRole === USERTYPES.RADIOLOGIST) {
        // modalityIdList.push(values.firstModalityPreference);
        // modalityIdList.push(values.secondModalityPreference);
        // modalityIdList.push(values.thirdModalityPreference);
        // console.log(modalityIdList)
          const userDto = {
            id: profileData.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
          
            //qcRadiologist: values.qcRadiologist ? 1 : 0,
            //showAllStudies: values.showAllStudies ? 1 : 0,
            sendAssignMail: values.sendAssignMail ? 1 : 0,
            checkCapacityOnManualAssign: values.checkCapacityOnManualAssign ? 1 : 0,
            //onPayroll: values.onPayroll,
            radiologistType: profileData.radiologistType,
            allhospitalAccess: profileData.allhospitalAccess,
            //radiologistProvider: userData.radiologistProvider,
            role,
            //whatsappUserpref: useWA,
            whatsappNumber: waPhone,
            //emailUserpref: useEmail,
            enableWhatsApp: enableWhatsAppFlag,
            enableEmail: enableEmailFlag,
            //firmIdList: checkFirm.filter((firm) => String(firm)),
            userFirmDto: {
              firmRequired: false,
            },
            signatureDto: {
              signatureRequired: profileData.signatureDto.signatureRequired,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            },
            capacity:profileData.capacity,
            modalityIdList:profileData.modalityIdList,
            specialist: (values.specialist || "").trim(),
            enableTypistWorkflow: values.enableTypistWorkflow,
            accountNonLocked : profileData.accountNonLocked,
            twoFactorEnabled: profileData.twoFactorEnabled ? 1 : 0,
            enableLlmReport: profileData.enableLlmReport ? 1 : 0,
            passwordResetAllowed: profileData.passwordResetAllowed ? 1 : 0,
            forcedLogoutAllowed: profileData.forcedLogoutAllowed ? 1 : 0,
            enableStudyUpload: profileData.enableStudyUpload ? 1 : 0,
            exportCsvAllowed: profileData.exportCsvAllowed ? 1 : 0,
            enableReportAndHeaderTemplateConfigurations: profileData.enableReportAndHeaderTemplateConfigurations ? 1 : 0,
            // showWord: values.showWord ? 1 : 0
          };
          console.log(userDto)
          response = await editRadiologist(userDto, userDto.signatureDto.signatureImage);
      
    }
    else if (
      loggedInUserRole === USERTYPES.TYPIST
    ) {
        const userDto = {
          id: profileData.id,
          username: encryptedUsername,
          firstName: encryptedFirstName,
          lastName: encryptedLastName,
          email: encryptedEmail,
          mobile: encryptedMobile,
          action: encryptedAction,
          active: values.active,
          accountNonLocked : profileData.accountNonLocked,
          role,
          //whatsappUserpref: useWA,
          whatsappNumber: waPhone,
          //emailUserpref: useEmail,
          enableWhatsApp: enableWhatsAppFlag,
          enableEmail: enableEmailFlag,
          signatureDto: {
            signatureRequired: false,
            isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
          },
        };
        
        response = await editUser(userDto);
      
    }
    return response;
};